import PublicHeader from "@/components/PublicHeader";

/**
 * Conditions Générales d'Utilisation et de Vente (CGU/CGV).
 * Template conforme aux exigences françaises (art. L121-19 Code conso, LCEN).
 * À faire valider par un juriste avant mise en production réelle.
 */
export default function CGU() {
    return (
        <div className="min-h-screen">
            <PublicHeader />
            <article className="max-w-3xl mx-auto pt-32 pb-24 px-6 sm:px-8 prose-tk">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#86868B] mb-3">Document légal</p>
                <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-[#1D1D1F]">
                    Conditions générales
                </h1>
                <p className="mt-3 text-sm text-[#86868B]">Dernière mise à jour : 18 février 2026</p>

                <Section title="1. Objet">
                    <p>
                        Les présentes conditions générales d&apos;utilisation et de vente (ci-après « CGU/CGV »)
                        régissent l&apos;utilisation du service Ticketify (le « Service ») édité par Ticketify SAS
                        (ci-après « Ticketify », « nous »).
                    </p>
                    <p>
                        Le Service permet aux utilisateurs (« vous », « Utilisateur ») de digitaliser, archiver et
                        gérer leurs justificatifs comptables à partir de leurs paiements carte et de leur boîte mail.
                    </p>
                </Section>

                <Section title="2. Acceptation">
                    <p>
                        L&apos;inscription au Service vaut acceptation pleine et entière des présentes CGU/CGV.
                        Si vous n&apos;acceptez pas ces conditions, vous ne devez pas utiliser le Service.
                    </p>
                </Section>

                <Section title="3. Inscription et accès">
                    <p>
                        L&apos;inscription est gratuite. Pour créer un compte, vous devez être majeur ou
                        représenter une personne morale. Vous vous engagez à fournir des informations exactes et à
                        maintenir vos identifiants confidentiels.
                    </p>
                </Section>

                <Section title="4. Abonnements payants">
                    <p>
                        Ticketify propose des plans gratuits et payants. Les plans payants (Pro à 39,99&nbsp;€/mois,
                        Business à 149,99&nbsp;€/mois) sont sans engagement et résiliables à tout moment depuis votre
                        espace utilisateur. Le paiement s&apos;effectue mensuellement via Stripe.
                    </p>
                    <p>
                        Conformément à l&apos;article L221-28 du Code de la consommation, le droit de rétractation
                        ne s&apos;applique pas dès lors que la prestation a commencé avec votre accord exprès et que
                        vous renoncez à votre droit de rétractation.
                    </p>
                </Section>

                <Section title="5. Limites du service">
                    <p>
                        Ticketify s&apos;efforce d&apos;extraire automatiquement les justificatifs depuis votre boîte
                        mail et de les apparier aux transactions bancaires importées. Aucune extraction automatique
                        n&apos;est garantie à 100&nbsp;%, certains marchands n&apos;envoyant pas de justificatif
                        électronique.
                    </p>
                </Section>

                <Section title="6. Données personnelles">
                    <p>
                        Le traitement de vos données personnelles est détaillé dans notre{" "}
                        <a href="/confidentialite" className="text-[#007AFF] hover:underline">
                            Politique de confidentialité
                        </a>.
                    </p>
                </Section>

                <Section title="7. Propriété intellectuelle">
                    <p>
                        L&apos;ensemble du Service, code source, marques et logos est la propriété exclusive de
                        Ticketify SAS. Toute reproduction ou utilisation non autorisée est interdite.
                    </p>
                </Section>

                <Section title="8. Responsabilité">
                    <p>
                        Ticketify s&apos;engage à fournir le Service avec soin mais ne peut être tenue responsable
                        des conséquences directes ou indirectes d&apos;une indisponibilité, perte de données ou
                        erreur d&apos;extraction OCR. L&apos;Utilisateur reste responsable de la conformité
                        comptable et fiscale de ses justificatifs.
                    </p>
                </Section>

                <Section title="9. Résiliation">
                    <p>
                        Vous pouvez résilier votre compte à tout moment depuis vos paramètres. Ticketify se réserve
                        le droit de suspendre ou supprimer un compte en cas de manquement aux CGU.
                    </p>
                </Section>

                <Section title="10. Modifications">
                    <p>
                        Les présentes CGU peuvent être modifiées. Toute modification substantielle vous sera
                        notifiée par email au moins 30 jours avant prise d&apos;effet.
                    </p>
                </Section>

                <Section title="11. Droit applicable">
                    <p>
                        Les présentes CGU sont soumises au droit français. Tout litige relèvera des tribunaux
                        compétents du ressort du siège social de Ticketify SAS, sous réserve des dispositions
                        impératives applicables aux consommateurs.
                    </p>
                </Section>

                <p className="mt-12 text-sm text-[#86868B] italic">
                    Ce document est un modèle. Il doit être complété et validé par un juriste avant la mise en
                    production commerciale.
                </p>
            </article>
            <Footer />
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section className="mt-10">
            <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-[#1D1D1F] mb-3">{title}</h2>
            <div className="space-y-3 text-[15px] leading-relaxed text-[#1D1D1F]/90">{children}</div>
        </section>
    );
}

function Footer() {
    return (
        <footer className="border-t border-black/5 py-10 px-6 sm:px-8 text-center text-sm text-[#86868B]">
            © 2026 Ticketify · <a href="/mentions-legales" className="hover:text-[#1D1D1F]">Mentions légales</a> ·{" "}
            <a href="/confidentialite" className="hover:text-[#1D1D1F]">Confidentialité</a>
        </footer>
    );
}
